import { render, staticRenderFns } from "./getTimeElectricshock.vue?vue&type=template&id=7487b18d&scoped=true&"
import script from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
export * from "./getTimeElectricshock.vue?vue&type=script&lang=js&"
import style0 from "./getTimeElectricshock.vue?vue&type=style&index=0&id=7487b18d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487b18d",
  null
  
)

export default component.exports